export const AssignmentDetailsMutations = {
  SetAssignmentDetailsLoading: 'setAssignmentDeatilsLoading',
  RetrieveAssignmentSuccess: 'retrieveAssignmentSuccess',
  RetrieveAssignmentTimeSheetsSuccess: 'retrieveAssignmentTimeSheetsSuccess',
  RetrieveAssignmentExpensesSuccess: 'retrieveAssignmentExpensesSuccess',
  RetrieveAssignmentAttachmentsSuccess: 'retrieveAssignmentAttachmentsSuccess',
  RetrieveAssignmentHistoriesSuccess: 'retrieveAssignmentHistoriesSuccess',
  DeleteAssignmentValidationErrorKeySuccess: 'editAssignmentValidationErrorsSuccess',
  SetAssignmentValidationErrorsSuccess: 'setAssignmentValidationErrorsSuccess',
  SetAssignmentTimeSheetsSortOrder: 'setAssignmentTimeSheetsSortOrder',
  SetAssignmentExpensesSortOrder: 'setAssignmentExpensesSortOrder',
  SetAssignmentTimesheetsLoading: 'setAssignmentTimesheetsLoading',
  SetAssignmentExpensesLoading: 'setAssignmentExpensesLoading',
  SetAssignmentTimeSheetsPaginationParams:
    'AssignmentDetailsMutations.SetAssignmentTimeSheetsPaginationParams',
  SetAssignmentExpensesPaginationParams:
    'AssignmentDetailsMutations.SetAssignmentExpensesPaginationParams',
  ResetAssignmentTimeSheetPaginationOffset:
    'AssignmentDetailsMutations.ResetAssignmentTimeSheetPaginationOffset',
  ResetAssignmentExpensePaginationOffset:
    'AssignmentDetailsMutations.ResetAssignmentExpensePaginationOffset',
  SetAssignmentTimeSheetRecordCount: 'AssignmentDetailsMutations.SetAssignmentTimeSheetRecordCount',
  SetAssignmentExpenseRecordCount: 'AssignmentDetailsMutations.SetAssignmentExpenseRecordCount'
};

export const AssignmentDetailsActions = {
  RetrieveAssignment: 'retrieveAssignment',
  RetrieveAssignmentTimeSheets: 'retrieveAssignmentTimeSheets',
  RetrieveAssignmentExpenses: 'retrieveAssignmentExpenses',
  RetrieveAssignmentHistories: 'retrieveAssignmentHistories',
  RetrieveAssignmentAttachments: 'retrieveAssignmentAttachments',
  DoAssignmentAction: 'doAssignmentAction',
  SetAssignmentValidationErrors: 'setAssignmentValidationErrors',
  SetAssignmentTimeSheetsSortOrder: 'setAssignmentTimeSheetsSortOrder',
  DeleteAssignmentValidationErrorKey: 'deleteAssignmentValidationErrorKey',
  SetAssignmentExpensesSortOrder: 'setAssignmentExpensesSortOrder',
  RetrieveAssignmentBillingMethod: 'retrieveAssignmentBillingMethod',
  CreateNewTimesheet: 'createNewTimesheetForAssignment',
  RetrieveAssignmentForPdf: 'retrieveAssignmentForPdf',
  RetrieveAssignmentExpensesRecordCount:
    'AssignmentDetailsActions.RetrieveAssignmentExpensesRecordCount',
  RetrieveAssignmentTimeSheetsRecordCount:
    'AssignmentDetailsActions.RetrieveAssignmentTimeSheetsRecordCount',
  SetAssignmentTimeSheetsPaginationParams:
    'AssignmentDetailsActions.SetAssignmentTimeSheetsPaginationParams',
  SetAssignmentExpensesPaginationParams:
    'AssignmentDetailsActions.SetAssignmentExpensesPaginationParams',
  RetrieveIfNotLoaded: 'AssignmentDetailsActions.RetrieveIfNotLoaded'
};

export const AssignmentDetailsGetters = {
  CurrentAssignment: 'CurrentAssignment',
  CurrentAssignmentBillingMethod: 'CurrentAssignmentBillingMethod',
  CurrentAssignmentTimeSheets: 'CurrentAssignmentTimeSheets',
  CurrentAssignmentExpenses: 'CurrentAssignmentExpenses',
  CurrentAssignmentHistories: 'CurrentAssignmentHistories',
  IsOnScreenAssignmentModified: 'IsOnScreenAssignmentModified',
  AssignmentId: 'AssignmentId',
  AssignmentValidationErrors: 'AssignmentValidationErrors',
  SelectedHistoryRecord: 'AssignmentDetailsGetters.SelectedHistoryRecord',
  AssignmentTimeSheetsSortOrder: 'AssignmentTimeSheetsSortOrder',
  AssignmentExpensesSortOrder: 'AssignmentExpensesSortOrder',
  IsAssignmentDetailsLoading: 'IsAssignmentDetailsLoading',
  CurrentAssignmentAttachments: 'CurrentAssignmentAttachments',
  IsAssignmentTimesheetsLoading: 'isAssignmentTimesheetsLoading',
  IsAssignmentExpensesLoading: 'isAssignmentExpensesLoading',
  AssignmentTimeSheetsPerPage: 'AssignmentDetailsGetters.AssignmentTimeSheetsPerPage',
  AssignmentExpensesPerPage: 'AssignmentDetailsGetters.AssignmentExpensesPerPage',
  CurrentAssignmentExpensesPage: 'AssignmentDetailsGetters.CurrentAssignmentExpensesPage',
  CurrentAssignmentTimeSheetsPage: 'AssignmentDetailsGetters.CurrentAssignmentTimeSheetsPage',
  AssignmentTimeSheetCount: 'AssignmentDetailsGetters.AssignmentTimeSheetCount',
  AssignmentExpenseCount: 'AssignmentDetailsGetters.AssignmentExpenseCount'
};
